<button *ngIf="(canShow$ | async)" class="dropdown-item" (click)="createNewVersion()">
  <span [innerHtml]="'item.page.version.create' | translate">
  </span>
</button>
